import React, { useState, useRef } from 'react';
import './index.less'
export default (props) => {
    const { recordArr } = props
    console.log(recordArr);
    const MONTH = [null, 'Jan.', 'Feb.', 'Mar.', 'Apr.', 'May.', 'Jun.', 'Jul.', 'Aug.', 'Sep.', 'Oct.', 'Nov.', 'Dec.']
    // 按地区统计
    let areaarr = []
    let total = 0
    // const datearr = recordArr[0]['开立日'].split('-')
    // const mon = Number(datearr[1])
    let len = recordArr.length
    if (!len) {
        return <h1>暫無數據</h1>
    }
    // 统计经过年月
    let beginDatearr = recordArr[0]['开立日'].split('-')
    let beginYear = beginDatearr[0]
    let beginMon = Number(beginDatearr[1])
    let beginDay = beginDatearr[2]
    let endDatearr = recordArr[len - 1]['开立日'].split('-')
    let endYear = endDatearr[0]
    let endMon = Number(endDatearr[1])
    let endDay = endDatearr[2]
    let monlen = (endYear - beginYear) * 12 + endMon - beginMon + 1
    if (monlen < 12) {
        monlen = 12
    }
    for (let i = 0; i < len; i++) {
        let item = recordArr[i]
        // 判断区域
        let index = areaarr.findIndex(item2 => item2.area == item['地区'])
        let money = item['票据金额']
        total += money
        // 判断月份 --- 注意可能会跨年份统计，需要确认文档格式,目前限制同一年内
        let datearr = item['开立日'].split('-')
        let year = datearr[0]
        let mon = Number(datearr[1])
        let monlen2 = (year - beginYear) * 12 + mon - 1
        if (index != -1) {
            // 判断项目
            let subarr = areaarr[index].subarr
            let index2 = subarr.findIndex(item2 => item2.ch_proj == item['捐款项目'])

            if (index2 != -1) {

                areaarr[index].subarr[index2].count = areaarr[index].subarr[index2].count + money
                areaarr[index].subarr[index2].monarr[monlen2] = areaarr[index].subarr[index2].monarr[monlen2] + money
            } else {
                let monarr = new Array(monlen).fill(0)
                monarr[monlen2] = money
                areaarr[index].subarr.push({
                    ch_proj: item['捐款项目'],
                    monarr: monarr.concat([]),
                    count: money
                })
            }
            let newmoney = areaarr[index].monTotalArr[monlen2] + money
            areaarr[index].monTotalArr[monlen2] = newmoney
            areaarr[index].total += money

        } else {

            let monarr = new Array(monlen).fill(0)
            monarr[monlen2] = money
            areaarr.push({
                area: item['地区'],
                subarr: [{
                    ch_proj: item['捐款项目'],
                    // 按月份统计
                    monarr: monarr.concat([]),
                    // 当前项目总金额
                    count: money
                }],
                // 当前地区总金额
                total: money,
                monTotalArr: monarr.concat([])
            })
        }


    }
    console.log('最终结果');
    console.log(areaarr);
    return (
        <div className='monthInvoice' id='monthInvoice'>
            <h3>Buddhist Compassion Relief Tzu Chi Foundation Phils., Inc.</h3>
            <h3>Monthly Fund and Project Breakdown</h3>
            <div className='month'><span>Period: {MONTH[beginMon] + beginDay + ',' + beginYear}-{MONTH[endMon] + endDay + ',' + endYear}</span><span>Currency Unit: PHP</span></div>
            <div className='monTitle'>
                <table border="1">
                    <thead>
                        <tr>
                            {MONTH.slice(1).map((item, index) => {

                                return (
                                    <th key={index}>{item}</th>
                                )
                            })}
                            <th>Total</th>
                        </tr>
                    </thead>
                </table>

            </div>
            {areaarr.map(item => {
                return (
                    <div key={item.area} className='areaItem'>
                        <div className='areaTitle'>Relief Fund ({item.area})</div>
                        {item.subarr.map(item2 => {
                            return (
                                <div key={item2.ch_proj} className='subItem style'>
                                    <div className='projItem'>{item2.ch_proj}</div>
                                    <div className='monArr'>
                                        {item2.monarr.map((item3, index3) => {
                                            return (
                                                <span key={index3}>{item3 == 0 ? '' : item3.toFixed(2)}</span>
                                            )
                                        })}
                                        <span>{item2.count.toFixed(2)}</span>
                                    </div>
                                </div>
                            )
                        })}
                        <div className='areaTotal style'>
                            <div className='areaName'>{item.area} Total Relief Fund</div>
                            <div className='count style'>
                                {item.monTotalArr.map((item2, index2) => {
                                    return (
                                        <span key={index2}>{item2.toFixed(2)}</span>
                                    )
                                })}
                                <span>{item.total.toFixed(2)}</span>
                            </div>
                        </div>
                    </div>
                )
            })}
            <div className='total style'>
                <span>Grand Total for Dev.Fund</span>
                <span>{total.toFixed(2)}</span>
            </div>
        </div>
    )
}